import React from 'react'
import { Form, FormGroup, FormFeedback, Row, Col, Button } from 'reactstrap';
import { FaUserAlt } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { NavLink } from 'react-router-dom'
import logo from '../image/login-icon.png';
import ErrorSwal from '../components/SwalError'
import { useTranslation } from 'react-i18next'
import { ForgetPass } from '../components/functions/LoginPage';


const schema = yup.object().shape({
    email: yup
        .string()
        .required("Please enter your Email"),

})

const ForgetPassword = () => {
    const { t } = useTranslation()

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = async (data) => {

        await ForgetPass(data)
            .then((response) => {
                ErrorSwal({
                    title: 'Success',
                    text: response.data.message,
                    icon: 'success'
                })
            })
            .catch(error => {
                console.log(error)
                ErrorSwal({
                    title: 'error',
                    text: error.response.data.message,
                    icon: 'error'
                })
            })

    }

    return (
        <>
            <div id="auth" style={{ backgroundColor: 'white' }}>

                <Row className="row h-100">
                    <Col lg={5} >
                        <div id="auth-left">
                            <div className="auth-logo">
                                <img src={logo} alt="Logo" srcSet="" />
                            </div>


                            <h1 className="auth-title" style={{ fontSize: '2.25rem', textAlign: 'center' }}> {t('t_forget_pass')} </h1>
                            <p className="auth-subtitle mb-4" style={{ fontSize: '1.25rem', textAlign: 'center' }}> {t('t_sub_forget_pass')} </p>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <FormGroup className="position-relative has-icon-left mb-4" >
                                    <div className="form-control-icon">
                                        <FaUserAlt size='2em' />
                                    </div>
                                    <input
                                        type="text"
                                        name="email"
                                        ref={register}
                                        className={`form-control-xl form-control ${errors.email ? "is-invalid" : ""}`}
                                        placeholder={t('i_email')}
                                    />
                                    {errors.email && (
                                        <FormFeedback type="invalid">
                                            {errors.email.message}
                                        </FormFeedback>
                                    )}
                                </FormGroup>



                                <Button color="primary" type="submit" className="btn btn-primary btn-block btn-lg shadow-lg mt-5">
                                    {t('b_send')}
                                </Button>
                            </Form>
                            <div className="text-center mt-5 text-lg fs-4">
                                <p className="text-gray-600">  {t('t_remember')} 
                                    {' '}
                                    <NavLink to="/" className="font-bold">
                                    {t('t_login')} 
                                    </NavLink>
                                </p>
                            </div>

                        </div>
                    </Col>
                    <Col lg={7} className="d-none d-lg-block">
                        <div id="auth-right">
                        </div>
                    </Col>


                </Row>
            </div>
        </ >
    )
}

export default ForgetPassword;
